<template>
  <div class="page">
    <!-- 广告图 -->
    <Banner />
    <!-- 猪肉区块链溯源 -->
    <Source />
  </div>
</template>

<script>
import Banner from './components/banner.vue'
import Source from './components/source.vue'
export default {
  components: {
    Banner,
    Source
  },
  data() {
    return {}
  },
  created() {
    console.log('溯源查询')
  }
}
</script>

<style lang="scss" scoped></style>
